module.exports = __webpack_public_path__ + "static/media/world-barn-dance.6fc341e8.vtt";